<div class="table-responsive">
  <ng-container *ngIf="msg.data | guardType: isHonourBoard as hb">
    <h6 class="small mb-0" [title]="hb.version">
      Campaign Honour Board: {{ hb.campaignId }}
    </h6>
    <table class="table table-sm table-bordered table-striped extra-small mb-0">
      <ng-container [ngSwitch]="hb.version">
        <ng-container
          *ngSwitchCase="
            ['conv1or2', 'conv3', 'conv1', 'conv1or2or3'].includes(hb.version)
              ? hb.version
              : ''
          "
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">
                {{
                  hb.version === "conv3"
                    ? "Conv3"
                    : hb.version === "conv1"
                    ? "Conv1"
                    : hb.version === "conv1or2or3"
                    ? "Conv1/2/3"
                    : "Conv1/2"
                }}
              </th>
              <th class="text-right">Conv/Hr</th>
              <th class="text-right">Conv/C</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">{{ kpi.sales }}</td>
              <td class="text-right">
                {{ kpi.sph | number: "1.2-2" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">{{ kpi.sales }}</td>
              <td class="text-right">
                {{ kpi.sph | number: "1.2-2" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container
          *ngSwitchCase="['v1', 'v1u16'].includes(hb.version) ? hb.version : ''"
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">
                {{ hb.version === "v1u16" ? "Upg" : "RG" }}
              </th>
              <th class="text-right">Avg $</th>
              <th class="text-right">RG/C</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">{{ kpi.sales }}</td>
              <td class="text-right">
                {{ kpi.vps | currency: "AUD":"symbol-narrow" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">{{ kpi.sales }}</td>
              <td class="text-right">
                {{ kpi.vps | currency: "AUD":"symbol-narrow" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container
          *ngSwitchCase="
            ['omnilead', 'q140'].includes(hb.version) ? hb.version : ''
          "
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">Leads</th>
              <th class="text-right">L/Hr</th>
              <th class="text-right">L/S</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">{{ kpi.products }}</td>
              <td class="text-right">
                {{ kpi.pph | number: "1.2-2" }}
              </td>
              <td class="text-right">
                {{ kpi.pps | number: "1.2-2" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">{{ kpi.products }}</td>
              <td class="text-right">
                {{ kpi.pph | number: "1.2-2" }}
              </td>
              <td class="text-right">
                {{ kpi.pps | number: "1.2-2" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container
          *ngSwitchCase="
            ['conv1or2q150', 'conv1or2q150u15'].includes(hb.version)
              ? hb.version
              : ''
          "
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">Tkts</th>
              <th class="text-right" *ngIf="hb.version === 'conv1or2q150'">
                T/Hr
              </th>
              <th class="text-right" *ngIf="hb.version === 'conv1or2q150u15'">
                $/Hr
              </th>
              <th class="text-right">T/C</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">{{ kpi.products }}</td>
              <td class="text-right" *ngIf="hb.version === 'conv1or2q150'">
                {{ kpi.pph | number: "1.2-2" }}
              </td>
              <td class="text-right" *ngIf="hb.version === 'conv1or2q150u15'">
                {{ kpi.sph | currency: "AUD":"symbol-narrow" }}
              </td>
              <td class="text-right">
                {{ kpi.ppc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">{{ kpi.products }}</td>
              <td class="text-right" *ngIf="hb.version === 'conv1or2q150'">
                {{ kpi.pph | number: "1.2-2" }}
              </td>
              <td class="text-right" *ngIf="hb.version === 'conv1or2q150u15'">
                {{ kpi.sph | currency: "AUD":"symbol-narrow" }}
              </td>
              <td class="text-right">
                {{ kpi.ppc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container
          *ngSwitchCase="
            ['conv1or2u15', 'conv1u15'].includes(hb.version) ? hb.version : ''
          "
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">$/Hr</th>
              <th class="text-right">SPC</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">
                {{ kpi.vph | currency: "AUD":"symbol-narrow" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">
                {{ kpi.vph | currency: "AUD":"symbol-narrow" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container
          *ngSwitchCase="
            ['conv1cph', 'conv1or2cph'].includes(hb.version) ? hb.version : ''
          "
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">U</th>
              <th class="text-right">CPH</th>
              <th class="text-right">S/C</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">
                {{ kpi.sales }}
              </td>
              <td class="text-right">
                {{ kpi.cph | number: "1.1-1" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">
                {{ kpi.sales }}
              </td>
              <td class="text-right">
                {{ kpi.cph | number: "1.1-1" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container
          *ngSwitchCase="['conv1u3'].includes(hb.version) ? hb.version : ''"
        >
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">S</th>
              <th class="text-right">S/H</th>
              <th class="text-right">S/C</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">
                {{ kpi.sales }}
              </td>
              <td class="text-right">
                {{ kpi.sph | number: "1.1-1" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">
                {{ kpi.sales }}
              </td>
              <td class="text-right">
                {{ kpi.sph | number: "1.1-1" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>
        <ng-container *ngSwitchCase="'orderitem'">
          <thead class="thead-dark">
            <tr>
              <th>Agent</th>
              <th class="text-right">Sales</th>
              <th class="text-right">SPH</th>
              <th class="text-right">SPC</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let kpi of hb.agentKpis | orderBy: 'rank'">
              <td>
                {{ kpi.userId | userName: "chat" | async }}
              </td>
              <td class="text-right">{{ kpi.products }}</td>
              <td class="text-right">
                {{ kpi.pph | number: "1.2-2" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
            <tr *ngIf="hb.total as kpi" class="table-secondary total-row">
              <td>Total</td>
              <td class="text-right">{{ kpi.products }}</td>
              <td class="text-right">
                {{ kpi.pph | number: "1.2-2" }}
              </td>
              <td class="text-right">
                {{ kpi.spc | percent: "1.1-1" }}
              </td>
            </tr>
          </tbody>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <tbody>
            <tr>
              <td>Unrecognised HonourBoard Type "{{ hb.version }}"</td>
            </tr>
          </tbody>
        </ng-container>
      </ng-container>
    </table>
  </ng-container>
</div>
